import { __extends } from "tslib";
import * as React from 'react';
import { DeprecatedInput } from '../../primitives/deprecated-input/input';
import { namespacedClassnames } from '../../common';
import { ColorPickerBoard } from './color-picker-board';
import { ColorPickerLineBoard } from './color-picker-line-board';
import * as Color from 'color';
import { Button } from '../../new-libby';
import { classNames } from '@wix/answers-lib';
import { Tooltip } from '../../primitives';
var withHash = function (color) { return "#" + color.replace('#', ''); };
var isPartialValidHexColor = function (color) { return /^#[0-9A-F]{0,6}$/i.test(withHash(color)); };
var isValidHexColor = function (color) { return isPartialValidHexColor(color) && withHash(color).length === 7; };
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputColor: _this.props.value,
            boardColor: Color(_this.props.value),
            prevColor: _this.props.value,
            validationError: ''
        };
        _this.onChangeColor = function (color, boardColor) {
            var hex = boardColor ? Color(boardColor).hex() : color;
            _this.setState({ inputColor: hex });
            _this.validateInput(hex);
            if (isValidHexColor(hex)) {
                _this.setState({ boardColor: boardColor || Color(color) });
            }
        };
        _this.validateInput = function (color) {
            if (isPartialValidHexColor(color)) {
                _this.setState({ validationError: '' });
            }
            else {
                _this.setState({ validationError: _this.props.texts.invalidHex || 'Invalid HEX Color' });
            }
        };
        _this.strictlyValidateInput = function () {
            var props = _this.props;
            if (!isValidHexColor(_this.state.inputColor)) {
                _this.setState({ validationError: props.texts.invalidHex || 'Invalid HEX Color' });
            }
        };
        _this.onCancel = function () {
            var prevColor = _this.state.prevColor;
            _this.setState({ inputColor: prevColor, boardColor: Color(prevColor), validationError: '' });
            _this.props.onCancel();
        };
        _this.onApply = function () {
            var inputColor = _this.state.inputColor;
            if (isValidHexColor(inputColor)) {
                _this.props.onChange(withHash(inputColor));
            }
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var isWhite = state.inputColor.toLocaleLowerCase() === '#fff' || state.inputColor.toLocaleLowerCase() === '#ffffff';
        return (React.createElement("div", { className: namespacedClassnames('color-picker') },
            React.createElement(ColorPickerBoard, { current: Color(this.state.boardColor), onChange: this.onChangeColor }),
            React.createElement(ColorPickerLineBoard, { current: Color(this.state.boardColor), onChange: this.onChangeColor }),
            React.createElement("div", { className: 'color-input-wrapper' },
                React.createElement(Tooltip, { body: props.texts.colorPreview || 'Color Preview' },
                    React.createElement("div", { className: classNames('color-preview', { isWhite: isWhite }), style: { background: state.inputColor } })),
                React.createElement(DeprecatedInput, { className: 'color-input', onChange: this.onChangeColor, value: state.inputColor, validationError: state.validationError, onEnter: this.strictlyValidateInput, onBlur: this.strictlyValidateInput, spellCheck: false, autoFocus: true })),
            React.createElement("div", { className: 'footer-container' },
                React.createElement(Button, { className: 'cancel-button', type: 'secondary', onClick: this.onCancel }, props.texts.cancel || 'Cancel'),
                React.createElement(Button, { className: 'apply-button', onClick: this.onApply }, props.texts.apply || 'Apply'))));
    };
    return ColorPicker;
}(React.PureComponent));
export { ColorPicker };
//# sourceMappingURL=color-picker.comp.js.map